import React from "react";
import { Link } from "react-router-dom";
import { Phone, MapPin } from "lucide-react";
import Logo from "./Logo";
import { COMPANY } from "../lib/constants";
import { useLang } from "../lib/i18n";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="border-t border-border bg-secondary/30" data-testid="site-footer">
      <div className="container-x py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <Logo />
          <p className="mt-5 max-w-md text-sm text-muted-foreground leading-relaxed">
            {t.footer.about}
          </p>
        </div>

        <div>
          <h4 className="font-display font-bold text-sm uppercase tracking-widest mb-4">{t.footer.serviceAreas}</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            {COMPANY.cities.map((c) => (
              <li key={c}>{c}, TX</li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold text-sm uppercase tracking-widest mb-4">{t.footer.contact}</h4>
          <ul className="space-y-3 text-sm">
            <li>
              <a
                href={COMPANY.phoneHref}
                className="flex items-center gap-2 text-foreground hover:text-primary transition-colors font-semibold"
                data-testid="footer-call-link"
              >
                <Phone size={16} /> {COMPANY.phoneDisplay}
              </a>
            </li>
            <li className="flex items-start gap-2 text-muted-foreground">
              <MapPin size={16} className="mt-0.5 shrink-0" /> Houston, TX
            </li>
            <li>
              <Link to="/contact" className="text-primary hover:underline font-medium" data-testid="footer-quote-link">
                {t.footer.getQuote}
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-border">
        <div className="container-x py-5 text-xs text-muted-foreground flex flex-col sm:flex-row justify-between items-center gap-3">
          <span>© {new Date().getFullYear()} HOUSTO A/C. {t.footer.copyright}</span>
          <span>{t.footer.tagline}</span>
        </div>
      </div>
    </footer>
  );
}
